import { Grid } from '@mui/material';

import Card from 'pages/InsightsPage/dashboards/Card';
import { FiltersForApiState } from 'pages/InsightsPage/dashboards/filtering/types';

import ResponseByKeywordCard from './ResponseByKeywordCard';

type AutoResponseSend = {
    send_name: string;
    campaign_name: string;
    audience_count: number;
    sends_attempted: number;
    sends_successful: number;
    delivery_rate: number;
    interactive: 'Yes' | 'No';
    send_scheduled_timestamp: string;
    response_rate: string;
};

type Props = {
    statsData: AutoResponseSend;
    filtersForApi?: FiltersForApiState;
};

const AutoResponseCards = ({ statsData, filtersForApi }: Props) => {
    const getFigure = (figure: string | number, isPercentage?: boolean) =>
        isPercentage ? `${figure}%` : Number(figure).toLocaleString();

    return (
        <>
            <Grid container item spacing={2} xs={12} md={2}>
                <Grid item xs={12}>
                    <Card isFigureCard label="Interactive Messages Sent">
                        {getFigure(statsData?.sends_successful)}
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <Card isFigureCard label="Response Rate">
                        {getFigure(statsData?.response_rate, true)}
                    </Card>
                </Grid>
            </Grid>
            <Grid item xs={12} md={10}>
                <ResponseByKeywordCard filtersForApi={filtersForApi} />
            </Grid>
        </>
    );
};

export default AutoResponseCards;
